// removed by extract-text-webpack-plugin
module.exports = {"ad":"index_3bMr7Xh"};


//////////////////
// WEBPACK FOOTER
// ./src/component/ad/index.css
// module id = 907
// module chunks = 0